@if (errorMessage) {
  <article *ifFeatureFlagEnabled="'public-navigation'" class="forbidden">
    <ftr-illustration [illustration]="forbiddenIllustration" size="large" [attr.aria-hidden]="true" />
    <p class="forbidden__message whitespace-pre-line">{{ errorMessage }}</p>
    <ftr-tertiary-button text="Go to Home" iconLeft="HomeOutline" theme="primary" (onClick)="goToHome()" />
  </article>
}

<ftr-page *ifFeatureFlagDisabled="'public-navigation'">
  @if (errorMessage) {
    <article>
      <ftr-alert type="error" class="block my-4" [renderAsMarkdown]="true">
        <div class="whitespace-pre-line">{{ errorMessage }}</div>
      </ftr-alert>
    </article>
  }
  <ng-container *ngTemplateOutlet="globalAdminPanel" />
</ftr-page>

@if (isGlobalAdmin()) {
  <ftr-page *ifFeatureFlagEnabled="'public-navigation'">
    <ng-container *ngTemplateOutlet="globalAdminPanel" />
  </ftr-page>
}

<ng-template #globalAdminPanel>
  @if (isGlobalAdmin() && addUserRouterLink(); as addUserRouterLink) {
    <article>
      <div>
        @if (isForbiddenCourtSystemForFtrStaff()) {
          <ftr-alert type="error" class="block my-4" [renderAsMarkdown]="true">
            <strong>DO NOT ADD YOURSELF TO THIS COURT SYSTEM!</strong>
            <br />
            You're a <strong>Global Admin</strong> but <ng-template *ngTemplateOutlet="courtSystemName" /> has
            <a
              href="https://www.notion.so/ftrlabs/Customer-we-do-not-support-10cb5c7fbf27809590f2ed004dbf0b52"
              target="_blank"
              >forbidden FTR staff from accessing it</a
            >.
          </ftr-alert>
        } @else {
          <ftr-alert type="info" class="block my-4" [renderAsMarkdown]="true">
            You're a <strong>Global Admin</strong>.
            <a [routerLink]="addUserRouterLink" [queryParams]="addUserQueryParams()">Click here</a> to add yourself to
            <ng-template *ngTemplateOutlet="courtSystemName" />. Once added, you'll be redirected to your intended page.
          </ftr-alert>
        }
      </div>
    </article>

    <ng-template #courtSystemName>
      @if (courtSystem(); as courtSystem) {
        <strong>{{ courtSystem.name }}</strong>
      } @else {
        this court system
      }
    </ng-template>
  }
</ng-template>
